import axios from 'axios';
import { ReactSVG } from 'react-svg';
import questions from '../assets/questions.svg';
import questionsJP from '../assets/questionsJP.svg';
import betaTest from '../assets/betaTest.svg';
import joinOurTeam from '../assets/joinOurTeam.svg';
import joinOurTeamJP from '../assets/joinOurTeamJP.svg';
import './Outro.css';
import { useRef, useState} from 'react';
import { faCheck, faSpinner} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation, Trans } from 'react-i18next';

const Outro = () => {
    const { t, i18n } = useTranslation();
    const [icon,setIcon]= useState(faCheck);
    const check: any = useRef(null);
    const iconRef: any = useRef(null)
    const checkAnimation = () => {
        check.current.animate(
          {width: '100%'}, { duration: 100, fill: "forwards", easing: "ease"}
          );
        setTimeout(() => {
          setIcon(faSpinner);
          iconRef.current.animate([{
            transform: 'rotate(0)'
          }, {transform: 'rotate(270deg)'} ], { duration: 1000});
        }, 80);
    
        setTimeout(() => {
          check.current.animate(
          {width: '22%'}, { duration: 150, fill: "forwards", easing: "ease"}
          );
          setIcon(faCheck);
        }, 1080);
        return;
      }

      const [email, setEmail] = useState<string>("");
      const changeHandler = (e:React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
      }
      const submitHandler = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        checkAnimation();
        try {
          const response = await axios
            .post("/api/v1/users/emails/add", {email: email});
          console.log(response);
        } catch(error:any) {
          console.log(error.response.data);
        }
      }

    return (
        <div className='outro-wrapper'>
            <div className='outro-cards-wrapper'>
                <ReactSVG src={i18n.resolvedLanguage === 'en' ? questions : questionsJP}></ReactSVG>
                {i18n.resolvedLanguage === 'en' ? <ReactSVG src={betaTest}></ReactSVG> : null}
                <ReactSVG id="join-us" src={i18n.resolvedLanguage === 'en' ? joinOurTeam : joinOurTeamJP}></ReactSVG>
            </div>
            <div className='outro__form'>
                <h3>
                  <Trans i18nKey='outro'>
                    Interested in<br></br>Finding out more?
                  </Trans>
                </h3>
                <form action="post" onSubmit={submitHandler} className="intro__content__flex__form outro__content__flex__form" id="contact">
                    <input placeholder={`${t('inputEmail')}`} onChange={changeHandler}>
                    </input>
                    <button ref={check} type="submit" className="intro__content__flex__button"> <FontAwesomeIcon ref={iconRef} icon={icon} /></button>
                </form>
            </div>
        </div>
    )
}

export default Outro;